<template>
  <ColumnWithHelp
    :resizable="false"
    :min-width="150"
    :title="$t('ADVERTISEMENT.BID.COLUMN_DESC_MAX_CPI_TITLE')"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_MAX_CPI_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot="{ row: { id, priceOffer } }">
      <BidPriceOfferColumnContent
        :id="id"
        :price-offer="priceOffer"
        :is-hovered="id === currentHoveredRowId"
      />
    </template>
  </ColumnWithHelp>
</template>

<script>
import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';
import BidPriceOfferColumnContent from './BidPriceOfferColumnContent';

export default {
  name: 'BidPriceOfferColumn',
  components: {
    ColumnWithHelp,
    BidPriceOfferColumnContent,
  },
  inheritAttrs: false,
  props: {
    currentHoveredRowId: {
      type: Number,
      required: true,
    },
  },
};
</script>
